<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form>
                <div class="alert alert-info" v-if="notice">{{ notice }}</div>
                <div class="alert alert-danger" v-if="error">{{ error }}</div>
                <div v-show="enableResetForm">
                  <h1>Reset Password</h1>
                  <p class="text-muted">Reset your password</p>
                  <b-row>
                    <b-col md="6">
                      <b-form-group id="passInputGroup5"
                                    label="Password"
                                    label-for="password">
                        <b-form-input id="password"
                                      type="password"
                                      v-model.trim="$v.form.password.$model"
                                      :state="chkState('password')"
                                      aria-describedby="input1LiveFeedback5"
                                      placeholder="Password"
                                      autocomplete='new-password' />
                        <b-form-invalid-feedback id="input1LiveFeedback5">
                          Required password containing at least: number, uppercase and lowercase letter, 8 characters
                        </b-form-invalid-feedback>
                      </b-form-group>

                    </b-col>
                    <b-col md="6">
                      <b-form-group id="confPassInputGroup6"
                                    label="Confirm password"
                                    label-for="confirm_password">
                        <b-form-input id="confirm_password"
                                      type="password"
                                      v-model.trim="$v.form.confirmPassword.$model"
                                      :state="chkState('confirmPassword')"
                                      aria-describedby="input1LiveFeedback6"
                                      placeholder="Confirm password"
                                      autocomplete='new-password' />
                        <b-form-invalid-feedback id="input1LiveFeedback6">
                          Passwords must match
                        </b-form-invalid-feedback>
                      </b-form-group>

                    </b-col>
                  </b-row>

                  <b-button variant="success" block :disabled="$v.form.$invalid" @click="reset">Reset</b-button>
                </div>
              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, sameAs, helpers } from "vuelidate/lib/validators"

const mustAccept = value => {
  return Boolean(value)
}
const strongPass = helpers.regex('strongPass', /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/)


const formShape = {
  password: "",
  confirmPassword: "",
}


export default {
  name: 'ResetPassword',
  data () {
    return {
      enableResetForm: true,
      uid: '',
      token: '',
      form: Object.assign({}, formShape),
      error: '',
      notice: ''
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        strongPass
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs("password")
      },
    }
  },  
  mounted () {
    this.checkPasswordToken()
  },
  methods: {
    chkState(val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },    
    reset () {
      const body = {
        token: this.token,
        [this.uid]: {password: this.form.password}
      };

      this.$http.put('/api/resetPassword', body)
      .then(response => {
          console.debug('reset password: ', response)
          this.resetSuccessful(response)
      })
      .catch(error => this.resetFailed(error))
    },
    resetSuccessful (response) {
      this.notice = 'Your password has been reset successfully! Please login with your new password.'
      this.error = ''
      this.form.password = ''
      this.form.password_confirmation = ''
      this.enableResetForm = false
    },
    resetFailed (error) {
      this.error = (error.response && error.response.data && error.response.data.error) || 'Something went wrong'
      this.notice = ''
    },
    checkPasswordToken () {
      if (!this.$route.query || !this.$route.query.uidHash || !this.$route.query.token) {
        this.error = 'Invalid link! Please click link from email.'
        this.notice = ''
        this.enableResetForm = false
        return        
      }
      this.$firebase.firestore().collection('emailVerifications').doc(this.$route.query.uidHash).get()
      .then(snapshot => {
        if (!snapshot.exists) {
          throw new Error('Invalid or Expired Link')
        }
        this.token = snapshot.data()['token'];
        this.uid = snapshot.data()['userID'];
        if (this.$route.query.token !== this.token) {
          throw new Error('Invalid or Expired Token')
        }
      })
      .catch(error => {
        this.error = error.message
        this.notice = ''
        this.enableResetForm = false
      })
    }
  }
}
</script>
